var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".record-select-box select{width:63px;height:25px;padding-left:17px;border-radius:2px;border:1px solid #ebebeb;font-size:13px;color:#333;outline:none;-moz-appearance:none;-webkit-appearance:none;background-image:url(" + escape(require("../../../assets/img/select.svg")) + ");background-position:calc(100% - .8em) 50%;background-repeat:no-repeat;background-color:#fff;cursor:pointer}.record-select-box select::-ms-expand{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50cd297d","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contents/shared/RecordSelectBox.vue
// module id = 265
// module chunks = 0